import React from "react";
import styled from "styled-components";
import { FlexRowContainer } from "@trailhead/core-ui";
import {
  Button as AsurionButton,
  breakpoints,
  Text,
  Icon,
} from "@trailhead/asurion-ui";
import { trackEvent } from "@trailhead/analytics";
import { triggerExpertMessagingOverlay } from "./TriggerExpertOverlay";
import { useSanitizedTranslation } from "@trailhead/i18n";
import { useChatClient } from "@trailhead/chat";

const ButtonContainer = styled(FlexRowContainer)`
  justify-content: center;
`;

const MainButtonContainer = styled(ButtonContainer)`
  padding-top: 20px;
`;

const IconContainer = styled.div`
  padding-left: 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const HeaderSubTitle = styled(Text)`
  margin: 1rem 0rem;
  text-align: center;
`;

const AsurionButtonWrapper = styled(AsurionButton)`
  height: auto;
  max-height: 3rem;
  margin: 1% 1%;

  ${breakpoints.sm} {
    max-width: 350px;
  }
`;

const TagButton = styled(AsurionButtonWrapper)`
  border-color: #a5aaaf;
  padding: 12px 20px;

  &:hover {
    border-color: #868889 !important;
  }
`;
const formatMdn = (mdn: string): string => {
  if (mdn.length < 10) {
    throw new Error("Invalid mdn. Mdn must be 10 characters or longer.");
  }

  return `(${mdn.substring(0, 3)}) ${mdn.substring(3, 6)}-${mdn.substring(
    6,
    10,
  )}`;
};

type DesktopButtonProps = {
  phoneNumber: string;
};

export const DesktopButtonContainer: React.FC<DesktopButtonProps> = ({
  phoneNumber,
}) => {
  const t = useSanitizedTranslation();
  const chatClient = useChatClient();

  return (
    <>
      <MainButtonContainer>
        <TagButton
          size="medium"
          variant="outline"
          color="secondary"
          onClick={() => {
            triggerExpertMessagingOverlay(chatClient);
            trackEvent("Chat_Prompt_Click", {
              buttonText: "Chat with an expert",
            });
          }}
        >
          <>
            {t("Chat with an expert")}
            <IconContainer>
              <Icon size="large" src="ChatBubbleCircle" />
            </IconContainer>
          </>
        </TagButton>
      </MainButtonContainer>
      <HeaderSubTitle size={3} weight={"feather"}>
        {`${t("Or, call us at")}${formatMdn(phoneNumber)}.`}
      </HeaderSubTitle>
    </>
  );
};
